export default "__VITE_ASSET__DJi7De_E__"